import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(async function () {

});



export function scheduleFreeDemoButton_click(event) {
    // Add your code for this event here: 

    wixWindow.trackEvent("CustomEvent", {
        "event": "Schedule Demo",
        "eventCategory": "Intent",
        "eventAction": "Click Schedule Demo Button",
        "eventLabel": "Schedule Demo",
        "eventValue": 50
    });

    wixLocation.to("/request-demo");
}

export function startTrialButton_click(event) {
    // Add your code for this event here: 
    wixWindow.trackEvent("CustomEvent", {
        "event": "Free Trial Button",
        "eventCategory": "Intent",
        "eventAction": "Click Free Trial Button",
        "eventLabel": "Free Trial",
        "eventValue": 50
    });

    wixLocation.to("https://www.barpay.com/go")
}